export {Textarea} from './textarea.component';
export type {TextareaProps} from './textarea.component';

